import React, {useState} from "react";
import Button from "../../common/Button";
import Resource from "./Resource";
import Underline from "../../../assets/underlines/1.png";
import Resource1 from "../../../assets/resources/r1.png";
import Resource2 from "../../../assets/resources/r2.png";
// import Resource3 from "../../../assets/resources/3.png";
// import Resource4 from "../../../assets/resources/4.png";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const UsefulResources = () => {
  const [showResources, setShowResources] = useState(false);
  const responsive = {
    tablet: {
      breakpoint: { max: 1024, min: 670 },
      items: 2,
      slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 670, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };

  const resources = [
    {
      tag: "Learn about PET",
      title: "Learn more about privacy-enchancing technologies, input and output privacy from the previous UN Handbook on Privacy-Preserving Computation Techniques.",
      image: Resource1,
      link: 'https://unstats.un.org/bigdata/task-teams/privacy/UN%20Handbook%20for%20Privacy-Preserving%20Techniques.pdf',
    },
    {
      tag: "Differential Privacy: A Primer for a Non-Technical Audience",
      title: "A gentle introduction to differential privacy � one of the privacy enhancing technologies that will be used during the hackathon.",
      image: Resource2,
      link: 'https://dash.harvard.edu/bitstream/handle/1/38323292/4_Wood_Final.pdf?sequence=1',
    },
  ];

  return (
    <div className="relative sm:max-w-container max-w-[90vw] mx-auto flex flex-col items-center md:mb-[150px] sm:mb-[125px] mb-[100px] z-10">
      <p className="uppercase font-semibold text-sm leading-5 text-warning text-center mb-8">
        Resources
      </p>

      <div className="flex flex-col items-center w-fit mb-[72px] sm:mb-24 md:mb-28">
        <p className="relative font-semibold md:text-[40px] text-3xl text-dark text-center mb-2">
          Useful Resources
          <img src={Underline} alt=":( Not Found" className=" absolute top-10 md:top-12" />
        </p>
      </div>

      <div className="w-full hidden md:flex flex-wrap mb-4">
        {resources.map((resource, index) => (
          <div key={index}
            className={"smooth " + ((showResources === false) && (index >= 4) ? " wrapHide" : " appear w-1/2 odd:pr-6 even:pl-6 mb-12 ") }>
            <Resource {...resource} />
          </div>
        ))}
      </div>

      <div className="w-full md:hidden flex-wrap mb-4 resources-carousel">
        <Carousel 
          responsive={responsive}
          // centerMode={window.innerWidth > "640" ? true : false}
          swipeable={true}
          draggable={true}
          showDots={true}
          // dotListClass="custom-dot-list-style"
          itemClass="carousel-item"
          arrows={false}
        >
          {resources.map((resource, index) => (
            <div key={index} className="mb-12 mx-auto w-[85%]">
              <Resource {...resource} />
            </div>
          ))}
        </Carousel>
      </div>

      {resources.length > 4 && window.innerWidth > "960" && <Button onClick={() => setShowResources(!showResources)}>
        {showResources === true ? "Hide" : "All Resources"}
      </Button>}
    </div>
  );
};

export default UsefulResources;
